{
  "SET_NEW_PASSWORD": {
    "TITLE": "Ievadiet jauno paroli",
    "PASSWORD": {
      "LABEL": "Parole",
      "PLACEHOLDER": "Parole",
      "ERROR": "Parole ir pārāk īsa."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Apstipriniet paroli",
      "PLACEHOLDER": "Apstipriniet Paroli",
      "ERROR": "Paroles nesakrīt."
    },
    "API": {
      "SUCCESS_MESSAGE": "Parole ir veiksmīgi nomainīta.",
      "ERROR_MESSAGE": "Nevarēja izveidot savienojumu ar Woot serveri. Lūdzu mēģiniet vēlreiz."
    },
    "CAPTCHA": {
      "ERROR": "Verifikācijas derīguma termiņš ir beidzies. Lūdzu, vēlreiz atrisiniet captcha."
    },
    "SUBMIT": "Iesniegt"
  }
}
